import cn from "classnames"

import styles from "./CountBar.module.scss"

import type { CountBarProps } from "./CountBar.types"

export const CountBar = (props: CountBarProps) => {
  const { limit, max = 100, value = 0 } = props
  const percentage = Math.trunc((value / max) * 100)
  const limitPercentage = Math.trunc((limit / max) * 100)
  const isOverLimit = value > limit
  const percentageMoreMax = percentage > 100

  return (
    <div className={cn(styles.wrapper, styles.container)}>
      <div className={styles.bar}>
        <div
          style={{
            width: `${percentageMoreMax ? 100 : percentage}%`,
            backgroundColor: `var(${isOverLimit ? "--dust-red-3-color" : "--polar-green-3-color"})`,
            height: "100%"
          }}
        />
      </div>
      <div className={cn(styles.wrapper, styles.xAxis)}>
        <span />
        <span />
        <span />
        <span />
        <span>{`${max}d${percentageMoreMax ? "+" : ""}`}</span>
      </div>
      <span className={styles.limit} style={{ left: `${limitPercentage}%` }} />
    </div>
  )
}
